export default "__VITE_ASSET__Cbe$NMX8__"